import convertImageToBase64 from '../../utils/converitr-imagen-base64';
import { formSchema } from '../../validaciones/validacionTorneos';
import { apiFetch } from '../../utils/api';

const toDateTime = (date, endOfDay = false) => {
    if (!date) return "";
    return `${date}T${endOfDay ? "23:59:00" : "00:00:00"}`;
};

export const torneosSlice = (set,get) => ({
    insertarTorneo: async () => {
        const result = formSchema.safeParse({ ...get().datos, imagen: get().imagen });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        else{
            set({error:null})
        }
        try {
            const datos = get().datos;
            const isNew = String(datos.id) === "0";
            const branchId = datos.sucursales?.[0]?.value;
            const payload = {
                branchId,
                name: datos.nombre,
                description: datos.descripcion || null,
                rules: datos.reglas || datos.detalle || null,
                backgroundColor: datos.hexFondo || "#FFFFFF",
                textColor: datos.hexTexto || "#000000",
                registrationStartsAt: toDateTime(datos.fechaInicioInscripcion),
                registrationEndsAt: toDateTime(datos.fechaFinInscripcion, true),
                startsAt: toDateTime(datos.fechaInicio),
                endsAt: toDateTime(datos.fechaFin, true),
                feeAmount: Number(datos.costo || 0),
                paymentInstructions: datos.instruccionesPago || null,
            };
            const data = await apiFetch(isNew ? "/api/tournaments" : `/api/tournaments/${datos.id}`,{
                method: isNew ? "POST" : "PUT",
                body: JSON.stringify(payload)
            });
            console.log('El dato',data);
            if(data.status){
                const tournamentId = data.data.id;
                await get().guardarDivisionBase(tournamentId, data.data.divisions || []);
                if(get().fileImagen){
                    await get().subirPortada(tournamentId);
                }
                await get().aplicarEstatus(tournamentId, data.data.status, datos.estatus);
                get().elNavigate(-1);
                get().limpiar();
            } else {
                window.notie?.alert({ type: "warning", text: data.message || "No se pudo guardar el torneo" });
            }
        } catch (error) {
            console.log('Error',error);
            window.notie?.alert({ type: "error", text: error.message || "Error al guardar torneo" });
        }
    },
    guardarDivisionBase: async (tournamentId, divisions = []) => {
        const datos = get().datos;
        const division = {
            name: datos.nombre,
            entrantType: datos.tipoTorneo || "team",
            teamSize: datos.tipoTorneo === "individual" ? 1 : 2,
            gender: datos.genero || "open",
            categoryMin: Number(datos.categoriaInicio),
            categoryMax: datos.categoriaFin ? Number(datos.categoriaFin) : Number(datos.categoriaInicio),
            format: datos.formato || "single_elimination",
            maxEntries: Number(datos.maxJugadores),
            approvalMode: datos.aprobacion || "automatic",
            waitlistEnabled: true,
            seedingMode: "manual",
        };
        const currentDivision = Array.isArray(divisions) ? divisions[0] : null;
        const data = await apiFetch(currentDivision?.id ? `/api/tournament-divisions/${currentDivision.id}` : `/api/tournaments/${tournamentId}/divisions`, {
            method: currentDivision?.id ? "PUT" : "POST",
            body: JSON.stringify(division),
        });
        if(!data.status){
            throw new Error(data.message || "No se pudo guardar la división del torneo");
        }
    },
    subirPortada: async (tournamentId) => {
        const formData = new FormData();
        formData.append('cover', get().fileImagen);
        const data = await apiFetch(`/api/tournaments/${tournamentId}/cover`,{
            method: "POST",
            body: formData
        });
        if(!data.status){
            throw new Error(data.message || "No se pudo subir la portada del torneo");
        }
        return data;
    },
    aplicarEstatus: async (tournamentId, currentStatus, targetStatus) => {
        if(!targetStatus || currentStatus === targetStatus) return;
        const transitionMap = {
            published: ["publish"],
            in_progress: ["publish", "start"],
            completed: ["publish", "start", "complete"],
            cancelled: ["cancel"],
        };
        const steps = transitionMap[targetStatus] || [];
        const alreadyDone = {
            draft: [],
            published: ["publish"],
            in_progress: ["publish", "start"],
            completed: ["publish", "start", "complete"],
            cancelled: ["cancel"],
        }[currentStatus] || [];
        const pendingSteps = steps.filter((step) => !alreadyDone.includes(step));
        for (const step of pendingSteps) {
            const data = await apiFetch(`/api/tournaments/${tournamentId}/${step}`, {
                method: "POST",
                body: JSON.stringify({}),
            });
            if(!data.status){
                throw new Error(data.message || "No se pudo actualizar el estatus del torneo");
            }
        }
    },
    obtenerImagen: async (id,imagen) => {
        let laImagen = imagen;
        try {
            let base64 = await convertImageToBase64(laImagen);
            set({ datos:{ ...get().datos, imagen: imagen }, imagen: base64 });
        } catch (error) {
            console.error('Error al convertir la imagen a base64:', error);
            set({ datos:{ ...get().datos, imagen: imagen }, imagen: "existente" });
        }
    },
    obtenerTorneo: async() => {
        const formatDate = (dateStr) => {
            if (!dateStr) return "";
            return dateStr.split('T')[0];
        };

        if(String(get().datos.id) !== "0"){
            try {
                const data = await apiFetch(`/api/tournaments/${get().datos.id}`,{
                    method: "GET",
                });
                console.log('data',data);
                if(data.status && data.data){
                   const torneoInfo = data.data;
                   const division = Array.isArray(torneoInfo.divisions) ? torneoInfo.divisions[0] : null;

                   set({datos:{
                        ...get().datos,
                        nombre:torneoInfo.name,
                        descripcion:torneoInfo.description || "",
                        reglas:torneoInfo.rules || "",
                        detalle:torneoInfo.rules || "",
                        hexFondo: torneoInfo.backgroundColor || "#FFFFFF",
                        hexTexto: torneoInfo.textColor || "#000000",
                        sucursales:get().sucursales.filter((item) => item.value === torneoInfo.branchId),
                        estatus:torneoInfo.status || "draft",
                        fechaInicio: formatDate(torneoInfo.startsAt),
                        fechaFin: formatDate(torneoInfo.endsAt),
                        fechaInicioInscripcion: formatDate(torneoInfo.registrationStartsAt),
                        fechaFinInscripcion: formatDate(torneoInfo.registrationEndsAt),
                        tipoTorneo: division?.entrantType || "team",
                        genero: division?.gender || "open",
                        formato: division?.format || "single_elimination",
                        aprobacion: division?.approvalMode || "automatic",
                        maxJugadores: division?.maxEntries || 8,
                        categoriaInicio: division?.categoryMin || "",
                        categoriaFin: division?.categoryMax && division?.categoryMax !== division?.categoryMin ? division.categoryMax : "",
                        costo: torneoInfo.feeAmount || "0",
                        instruccionesPago: torneoInfo.paymentInstructions || "",
                    }});
                    if(torneoInfo.coverUrl || torneoInfo.coverImageUrl){
                        get().obtenerImagen(torneoInfo.id,torneoInfo.coverUrl || torneoInfo.coverImageUrl);
                    }
                }
            } catch (error) {
                console.log('Error',error);
            }
        }   
    }
})
